import { useState, useEffect } from 'react'

export default function useAPI<T>(
  apiCall: () => Promise<T>,
): [T | null, () => void] {
  const [data, setData] = useState<T | null>(null)

  const refetch = async () => {
    setData(await apiCall())
  }

  useEffect(() => {
    refetch()
    // eslint-disable-next-line
  }, [apiCall])

  return [data, refetch]
}
